// This icon file is generated automatically.
var AdobeFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.6 1H20v18L12.6 1zM0 1h7.4L0 19V1zm6.77 14.58L10 7.26 14.71 19h-3.08l-1.41-3.42H6.77z", "fill-rule": "evenodd" } }] }, "name": "adobe", "theme": "filled" };
export default AdobeFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/AdobeFilled.js
// module id = 1942
// module chunks = 0